// @flow
import type {Observable, PureComputed, Disposable} from "rgs-knockout/types";
import ko from 'rgs-knockout';
import _ from 'lodash';

import {withProps} from "../helpers";


export type ArgsCheckboxChange = {
	id: number | string,
	isChecked: boolean,
};

export type Argument = {
	checked?: Observable<boolean> | boolean;
	isDisabled?: Observable<boolean> | boolean;
	content?: HTMLElement | string;
	onChange?: (ArgsCheckboxChange) => any;

	props?: Argument;
}


export type CheckboxArguments = Argument;

export default class Checkbox {
	id: string | number;

	onChange: (ArgsCheckboxChange) => void;
	unsubscribe: Disposable;

	props: {
		checked: Observable<boolean>,
		isDisabled: Observable<boolean>,
		content: PureComputed<string | HTMLElement>,
	};

	constructor (options: Argument) {
		const {
			checked = ko.observable(false),
			isDisabled = ko.observable(false),
			onChange = _.noop,
			id = 0,
			content = '',
		} = withProps(options);

		this.onChange = onChange;
		this.id = id;

		this.props = {
			checked: checked,
			isDisabled: isDisabled,
			content: ko.pureComputed(() => ko.unwrap(content)),
		};

		this.setHandlersOnChange();
	}

	setHandlersOnChange () {
		this.unsubscribe = this.props.checked.subscribe(value => {
			let result = this.onChange({id: this.id, isChecked: value});

			if (result === undefined) {
				result = value;
			}

			this.props.checked(result);
		});
	}

	dispose () {
		if (this.unsubscribe) {
			this.unsubscribe.dispose();
		}

	}
}
